import { useAppStore } from '../store/useAppStore';
import { supportsAdDataFreshness } from '../lib/adDataFreshness';

// Today's shortcut and freshness note share the same supported delivery sites.
export function useDeliverySiteScope() {
  const { brand, brandId, siteId, sites, sitesLoaded } = useAppStore();
  const site = sites.find(item => item.id === siteId && item.brand_id === brandId);
  return sitesLoaded && !!site && supportsAdDataFreshness(brand, site.code);
}
